export default "__VITE_ASSET__DY$15P64__"